import './App.css';
import Calc from "./components/Calc";

function App() {
  return (
    <div className="App">
      <Calc />
      <br />
      <i><small><a href="http:\\www.louisallard.fr" target="_blank" rel="noreferrer">www.louisallard.fr</a></small></i>
    </div>
  );
}

export default App;
